import { BasicDetailsProps } from "@hubcapp/views/MyBusinessProfile/types";
import {
  Box,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  makeStyles,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import AdditionalLanguagesMultiSelect from "./components/AdditionalLanguagesMultiSelect";
import React from "react";

const useStyles = makeStyles(theme => ({
  header: {
    display: "flex",
    justifyContent: "space-between",
  },
  sectionTitle: {
    margin: theme.spacing(0, 0, 2, 0),
  },
  title: {
    padding: theme.spacing(0),
    marginBottom: theme.spacing(2),
  },
  subTitle: {
    fontWeight: 300,
    fontSize: "15px",
  },
  loading: {
    paddingTop: theme.spacing(2),
  },
}));

const BasicDetails: React.FC<BasicDetailsProps> = ({
  values,
  additionalLanguageOptions,
  onDisplayNameChange,
  onAdditionalLanguageChange,
  errors,
  loading,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Card>
      <CardContent>
        <Grid container direction={"row"} wrap="wrap" justify="space-between">
          <Grid item sm={12} xs={12}>
            <Typography
              variant="h2"
              color="textSecondary"
              className={classes.title}
            >
              Basic details
            </Typography>
            <Typography
              variant="h3"
              color="textPrimary"
              className={classes.subTitle}
            >
              This information will be shown on your public business profile.
            </Typography>
          </Grid>
          {loading ? (
            <Grid container spacing={2} className={classes.loading}>
              {[...Array(2)].map((_, idx) => (
                <Grid item xs={12} sm={6} key={idx}>
                  <Box mb={2}>
                    <Skeleton key={idx} width="100%" height="35px" />
                  </Box>
                </Grid>
              ))}
            </Grid>
          ) : (
            <>
              <Grid container spacing={isMobile ? 1 : 6}>
                <Grid item sm={6} xs={12}>
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Display name"
                    name="displayName"
                    value={values?.displayName || ""}
                    variant="outlined"
                    inputProps={{
                      ["data-test"]: "profile-details-display-name-input",
                    }}
                    onChange={onDisplayNameChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    error={Boolean(errors?.displayName)}
                    helperText={errors?.displayName?.message || ""}
                  />
                </Grid>
                <Grid item sm={6} xs={12}>
                  <AdditionalLanguagesMultiSelect
                    additionalLanguageOptions={additionalLanguageOptions}
                    onAdditionalLanguageChange={onAdditionalLanguageChange}
                    values={values?.additionalLanguages || []}
                  />
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default BasicDetails;
